import { Grid, Switch, Tooltip, Typography } from '@mui/material';
import CustomPaper from '../../common/CustomPaper';
import LoopIcon from '@mui/icons-material/Loop';
import React from 'react';
import { styled } from '@mui/material/styles';

const LoopModeToggleContainer = styled(CustomPaper)(({ loopMode }) => ({
  padding: '8px 12px',
  marginBottom: '16px',
  borderRadius: '8px',
  background: loopMode ? 'rgba(158, 158, 158, 0.12)' : 'rgba(0, 0, 0, 0.03)',
  transition: 'background-color 0.3s ease, transform 0.2s ease',
  border: loopMode ? '1px solid rgba(158, 158, 158, 0.25)' : '1px solid transparent',
  '&:hover': {
    background: loopMode ? 'rgba(158, 158, 158, 0.18)' : 'rgba(0, 0, 0, 0.05)',
    transform: 'translateY(-1px)',
  },
}));

const LoopModeTitle = styled(Typography)(({ loopMode }) => ({
  fontWeight: loopMode ? LARGE_FONT : SMALL_FONT,
}));

const AnimatedLoopIcon = styled(LoopIcon)(({ loopMode }) => ({
  color: loopMode ? 'text.primary' : 'text.secondary',
  transform: loopMode ? 'rotate(360deg)' : 'rotate(0deg)',
  transition: 'transform 0.6s ease, color 0.3s ease',
}));

const SMALL_FONT = 400;
const LARGE_FONT = 600;

export function LoopModeToggle(props) {
  return (
    <LoopModeToggleContainer elevation={0} loopMode={props.loopMode}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Grid container alignItems="center" spacing={1.5}>
            <Grid item>
              <AnimatedLoopIcon loopMode={props.loopMode} />
            </Grid>
            <Grid item>
              <LoopModeTitle variant="subtitle2" loopMode={props.loopMode}>
                Loop Mode
              </LoopModeTitle>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Tooltip title="Toggle loop mode to enable loops within the same workflow">
            <Switch checked={props.loopMode} onChange={props.onChange} color="primary" />
          </Tooltip>
        </Grid>
      </Grid>
    </LoopModeToggleContainer>
  );
}
